import { useCallback, useLayoutEffect, useRef, useState } from 'react';

// Sub-pixel scroll positions on scaled displays never land exactly on the bottom.
const BOTTOM_TOLERANCE_PX = 1;

// Tracks whether a scrollable element still has content hidden below its visible area, so the
// caller can show a fade that disappears once the user reaches the end.
export function useHasMoreBelow<T extends HTMLElement>() {
    const ref = useRef<T>(null);
    const [hasMoreBelow, setHasMoreBelow] = useState(false);

    const update = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        setHasMoreBelow(el.scrollHeight - el.scrollTop - el.clientHeight > BOTTOM_TOLERANCE_PX);
    }, []);

    // No dependency list: content can change on any render, and an unchanged value bails out.
    useLayoutEffect(update);

    return { ref, hasMoreBelow, onScroll: update };
}
